import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/common/common.service';
import { GeneralConfiService } from '../general-confi.service';
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-edit-configuration',
  templateUrl: './edit-configuration.component.html',
  styleUrls: ['./edit-configuration.component.css']
})
export class EditConfigurationComponent implements OnInit {

  configurationType: String;
  awarenessList: any;
  stepList: any;
  generalForm: FormGroup;
  isEditAwarness: boolean = false;
  isEditStep: boolean = false;
  formSubmitted: boolean = false;




  constructor(private router: Router, private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private GeneralConfiService: GeneralConfiService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(param => {
      this.configurationType = param['type'];
    });
    this.getconfiguration(this.configurationType)
    this.initialiseForms();


  }

  initialiseForms() {
    this.generalForm = this.fb.group({
      title: ["", [Validators]],
      imageUrl: [, [Validators]],
      videoUrl: [, [Validators]]
    });
  }



  addAwarness() {

    this.awarenessList.push({ title: this.generalForm.value.title.toUpperCase(), imageUrl: this.generalForm.value.imageUrl.trim(), videoUrl: this.generalForm.value.videoUrl.trim() })
    this.generalForm.controls['title'].setValue(" ");
    this.generalForm.controls['imageUrl'].setValue(" ");
    this.generalForm.controls['videoUrl'].setValue(" ");

  }
  addSteps() {

    this.stepList.push({ imageUrl: this.generalForm.value.imageUrl.trim() })
    this.generalForm.controls['imageUrl'].setValue(" ");

  }
  dropAwarness(event: CdkDragDrop<string[]>) {
    //isPointerOverContainer is used to remove from dragbox
    if (event.isPointerOverContainer == false) {
      this.awarenessList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.awarenessList, event.previousIndex, event.currentIndex);

  }
  dropSteps(event: CdkDragDrop<string[]>) {
    if (event.isPointerOverContainer == false) {
      this.stepList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.stepList, event.previousIndex, event.currentIndex);

  }


  getconfiguration(type: any) {
    if (type == 'Awarness') {
      this.GeneralConfiService.getawarnessList().subscribe(res => {
        this.spinner.hide();
        if ((res["message"] = "Success")) {
          this.awarenessList = res.data.awarenessList;
          let length = this.awarenessList.length;
          if (length > 0) {
            this.isEditStep = true;
          }

        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: res.msg
          });
        }
      });
    } else {
      this.GeneralConfiService.getStepList().subscribe(res => {
        this.spinner.hide();
        if ((res["message"] = "Success")) {
          this.stepList = res.data.stepList;
          let length = this.stepList.length;
          if (length > 0) {
            this.isEditStep = true;
          }
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: res.msg
          });
        }
      });

    }


  }


  sumbit() {
    let awarness = [];
    let step = [];
    if (this.configurationType == 'Awarness') {

      let requestObj = {
        awarenessList: []
      }
      this.formSubmitted = true;
      this.awarenessList.forEach((element, index) => {
        awarness.push({ title: element.title, sortOrder: index, imageUrl: element.imageUrl, videoUrl: element.videoUrl });

      });
      requestObj.awarenessList = awarness
      let length = this.awarenessList.length;
      if (length > 0) {
        this.GeneralConfiService.editawarness(requestObj).subscribe(data => {
          if (data["message"] == "Success") {
            Swal.fire("Success", "Awarness Updated successfully!", "success");
            this.router.navigate(['main/general/']);

          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: data.msg
            });
          }
        });
      } else {
        this.GeneralConfiService.saveawarness(requestObj).subscribe(data => {
          if (data["message"] == "Success") {
            Swal.fire("Success", "Awarness Added successfully!", "success");
            this.router.navigate(['main/general/']);

          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: data.msg
            });
          }
        });

      }


    }
    if (this.configurationType == 'steps') {

      let requestObj = {
        stepList: []
      }
      this.formSubmitted = true;

      this.stepList.forEach((element, index) => {
        step.push({ sortOrder: index, imageUrl: element.imageUrl });

      });
      requestObj.stepList = step
      let length = this.stepList.length;
      if (length > 0) {
        this.GeneralConfiService.editstep(requestObj).subscribe(data => {
          if (data["message"] == "Success") {
            Swal.fire("Success", "Step Updated successfully!", "success");
            this.router.navigate(['main/general/']);

          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: data.msg
            });
          }
        });
      } else {
        this.GeneralConfiService.savestep(requestObj).subscribe(data => {
          if (data["message"] == "Success") {
            Swal.fire("Success", "Steps Added successfully!", "success");
            this.router.navigate(['main/general/']);

          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: data.msg
            });
          }
        });

      }
    }

  }





  cancel() {
    this.router.navigate(['main/general/']);
  }
}
